export default __webpack_public_path__ + "static/media/china_dark.af8eb53c.png";